import React from "react";

import { useFeature } from "flagged";

import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

import { InstructorTransactionsProps } from "@hubcapp/components/InstructorTransactions/types";
import { getNextAndLastInvoiceRun } from "@ds-developer/frontend";
import TransactionsTable from "@ds-developer/transactions-table";

import { filterPast, mapGraphToTableTransactions } from "./utils";
import { useQueryInstructorArrears } from "@hubcapp/hooks";
import ArrearsTable from "./ArrearsTable";
import useInstructorTransactionsData from "./hooks/useGetInstructorTransactionsData";

const InstructorTransactions: React.FC<InstructorTransactionsProps> = ({
  instructorId,
}) => {
  const useStyles = makeStyles(theme => ({
    addTransactionButton: {
      marginLeft: theme.spacing(3),
    },
    weekTitle: {
      display: "inline-block",
    },
    weekSubtitle: {
      display: "inline-block",
      marginLeft: theme.spacing(1),
    },
  }));

  const classes = useStyles();

  const { loading, data } = useInstructorTransactionsData(instructorId);

  const otherTransactions = (data?.instructor.ledgerItems || []).filter(
    filterPast,
  );

  const {
    loading: arrearsLoading,
    data: arrearsData,
  } = useQueryInstructorArrears(instructorId);
  const arrearsTableEnabled = useFeature("instructorArrearsEnabled");

  const arrearsTableShouldShow =
    arrearsTableEnabled &&
    arrearsData?.instructor.arrears &&
    arrearsData.instructor.arrears.length > 0;

  const { lastInvoiceRun, nextInvoiceRun } = getNextAndLastInvoiceRun();

  const range = { start: lastInvoiceRun, end: nextInvoiceRun };

  return (
    <Box>
      {arrearsTableShouldShow && (
        <Grid item sm={12}>
          <Box mb={3}>
            <Typography
              data-test="arrears-header"
              variant="h2"
              className={classes.weekTitle}
            >
              {"Arrears"}
            </Typography>
          </Box>

          <Box mb={3}>
            <ArrearsTable
              isLoading={arrearsLoading}
              arrears={arrearsData.instructor.arrears || []}
              id={instructorId}
            />
          </Box>
        </Grid>
      )}
      <Grid item sm={12}>
        <Box mb={3}>
          <Typography variant="h2" className={classes.weekTitle}>
            {"This week's transactions"}
          </Typography>
        </Box>
      </Grid>
      <TransactionsTable
        loading={loading}
        transactions={mapGraphToTableTransactions(otherTransactions)}
        showActions={false}
        showSubtotalRow
        range={range}
      />
    </Box>
  );
};

export default InstructorTransactions;
